"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESIGN_SYSTEM = void 0;
// can be changed to object - key, value pair
exports.DESIGN_SYSTEM = 'design-system';
